// Hair Extensions Guide (pages/extensions-guide.html): live prices, shades, products, FAQ and SEO
(function () {
  const e = LC.escape;
  const find = LC.findProduct;
  const path = LC.pageUrl('extensions-guide');

  /* ---------- Halo vs clip-in ---------- */
  const halos = ['14-16-remy-halo-extensions', '16-18-remy-halo-extensions'].map(find).filter(Boolean);
  const clips = ['18-clip-in-extensions', '22-clip-in-extensions'].map(find).filter(Boolean);
  const lengthLabel = (p) => p.name.replace(/\s*(Remy Halo|Clip-In) Extensions/i, '');
  const priceRows = (list) => list.map((p) => `
    <li><a href="${LC.productUrl(p.id)}"><span>${e(lengthLabel(p))} ${/halo/i.test(p.name) ? 'halo' : 'clip-in'}</span><strong>${p.price != null ? LC.formatPrice(p.price) : 'Coming soon'}</strong></a></li>`).join('');

  const compare = document.getElementById('ext-compare');
  if (compare) {
    compare.innerHTML = `
      <div class="compare-card is-feature">
        <p class="compare-kicker">The signature</p>
        <h3>Halo Hair Extensions</h3>
        <p>One piece on an invisible, adjustable wire that rests beneath your own hair. On and off in minutes, with no glue, clips or heat.</p>
        <ul class="compare-points">
          <li>No glue, chemicals or heat</li>
          <li>Full 360-degree movement</li>
          <li>Optional clips included for extra hold</li>
        </ul>
        <ul class="compare-prices">${priceRows(halos)}</ul>
        <a class="btn btn-light" href="${LC.productUrl(halos[halos.length - 1].id)}">Shop Halo Extensions</a>
      </div>
      <div class="compare-card">
        <p class="compare-kicker">The customizable</p>
        <h3>Clip-In Hair Extensions</h3>
        <p>Individual wefts you place exactly where you want fullness, for added length and volume you can unclip after wear.</p>
        <ul class="compare-points">
          <li>100% Remy human hair</li>
          <li>Flexible, section-by-section placement</li>
          <li>Removable, with no permanent installation</li>
        </ul>
        <ul class="compare-prices">${priceRows(clips)}</ul>
        <a class="btn btn-dark" href="${LC.productUrl(clips[0].id)}">Shop Clip-In Extensions</a>
      </div>`;
  }

  /* ---------- Shade library ---------- */
  const halo = find('16-18-remy-halo-extensions') || halos[0];
  const shades = document.getElementById('ext-shades');
  if (shades && halo) {
    const families = { Black: [], Brown: [], Blonde: [], Red: [], Blends: [] };
    halo.options.forEach((o) => {
      const m = o.name.match(/^#([\dA-Z]+)(?:\/([\dA-Z]+))?\s+(.*)$/);
      if (!m) return;
      const [, a, b, label] = m;
      const code = b ? `${a}/${b}` : a;
      const sw = LC.shadeSwatch(o.name);
      const swatch = sw.bg;
      const isNew = sw.isNew;
      const n = parseInt(a, 10);
      const family = b ? 'Blends' : /mahogany|chestnut/i.test(label) ? 'Red'
        : /black/i.test(label) ? 'Black' : n >= 10 || /blonde/i.test(label) ? 'Blonde' : 'Brown';
      families[family].push({ code, label, swatch, isNew });
    });
    shades.innerHTML = Object.entries(families).filter(([, list]) => list.length).map(([fam, list]) => `
      <div class="shade-family">
        <h3>${e(fam)} hair extension shades</h3>
        <ul>
          ${list.map((s) => `<li><span class="shade-dot" style="background:${s.swatch}" aria-hidden="true"></span><span class="shade-code">#${e(s.code)}</span><span class="shade-name">${e(s.label)}${s.isNew ? ' <em class="shade-new-tag">New</em>' : ''}</span></li>`).join('')}
        </ul>
      </div>`).join('');
    const count = document.getElementById('ext-shade-count');
    if (count) count.textContent = String(halo.options.length);
  }

  /* ---------- Shop, reads and FAQ ---------- */
  const extProducts = [...halos, ...clips];
  const shop = document.getElementById('ext-shop');
  if (shop) shop.innerHTML = extProducts.map(LC.cardHTML).join('');
  const reads = document.getElementById('ext-reads');
  if (reads) reads.innerHTML = LC.journal().filter((a) => a.category === 'Extensions').slice(0, 3).map(LC.storyCardHTML).join('');

  const P = LC.storeFaqs();
  const faqs = [
    { q: 'Which is better, halo or clip-in hair extensions?', a: 'Choose halo hair extensions for the fastest, damage-free application: one piece sits on a fitted wire beneath your own hair in minutes, with no glue, clips or heat. Choose clip-in hair extensions if you want to place individual wefts exactly where you want added fullness.' },
    { q: 'How much do Le Chic Beauty hair extensions cost?', a: `Le Chic Beauty halo extensions are ${halos.map((p) => `${LC.formatPrice(p.price)} for ${lengthLabel(p)}`).join(' and ')}. Le Chic Beauty clip-in extensions are ${clips.map((p) => `${LC.formatPrice(p.price)} for ${lengthLabel(p)}`).join(' and ')}.` },
    { q: 'How do I choose the right hair extension shade?', a: 'Match the extension shade to the ends of your hair, not your roots, and compare in natural daylight. If you are between two shades, a dimensional blend such as #4/27 or #18/24 softens the transition. Le Chic Beauty Customer Care can also help you choose.' },
    { q: 'How often should I wash human hair extensions?', a: 'Wash human hair extensions every 2–3 months if you wear them once or twice a week, and more often if you wear them frequently or use a lot of styling products. Always use a sulfate-free shampoo.' },
    { q: P.remy[0], a: `${P.remy[1]}.` },
    { q: P.haloDamage[0], a: `${P.haloDamage[1]}.` },
    { q: P.haloHold[0], a: `${P.haloHold[1]}.` },
    { q: P.haloLast[0], a: `${P.haloLast[1]}.` },
    { q: 'Can I color or perm human hair extensions?', a: 'You can color Le Chic Beauty human hair extensions; for a seamless match, have a stylist color them, or do a strand test first at home. Perming is not recommended because it can dry out and damage the hair.' },
    { q: 'Can I sleep or swim in halo extensions?', a: 'Sleeping in halo extensions is not recommended; they are easy to remove and hang overnight. Swimming in them is also not recommended unless you are using the included optional clips.' }
  ];
  const faqEl = document.getElementById('ext-faq');
  if (faqEl) faqEl.innerHTML = faqs.map((f, i) => `<details${i === 0 ? ' open' : ''}><summary>${e(f.q)}</summary><p>${e(f.a)}</p></details>`).join('');

  /* ---------- SEO ---------- */
  const stepsFrom = (sel) => Array.from(document.querySelectorAll(sel)).map((li) => ({
    name: (li.querySelector('h3') || {}).textContent || '',
    text: (li.querySelector('p') || {}).textContent || ''
  }));
  const title = 'Hair Extensions Guide: Halo vs Clip-In, Shades & Care | Le Chic Beauty';
  const description = 'How to choose, wear and care for human hair extensions: halo vs clip-in, how to put on a halo in 3 steps, a 28-shade matching guide and a 5-step washing routine.';
  LC.seo({
    title,
    description,
    path,
    image: 'images/m-vivienne.jpg',
    imageAlt: 'Model with long, glossy honey-blonde hair',
    type: 'article',
    jsonld: [
      LC.webPageLd('WebPage', path, title, description, { breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` } }),
      Object.assign(LC.breadcrumbLd([['Home', 'index.html'], ['Hair Extensions Guide', path]]), { '@id': `${LC.abs(path)}#breadcrumb` }),
      {
        '@type': 'Article',
        '@id': `${LC.abs(path)}#article`,
        headline: 'How to Choose, Wear & Care for Hair Extensions',
        description,
        image: LC.abs('images/m-vivienne.jpg'),
        author: { '@id': `${LC.SITE}#organization` },
        publisher: { '@id': `${LC.SITE}#organization` },
        mainEntityOfPage: { '@id': `${LC.abs(path)}#webpage` }
      },
      Object.assign(LC.howToLd('How to wear halo hair extensions', 'Put on a halo hair extension in three steps: section, place and blend.', stepsFrom('.guide-steps li'), path, 'images/m-vivienne.jpg'), { '@id': `${LC.abs(path)}#howto-wear` }),
      Object.assign(LC.howToLd('How to wash and care for human hair extensions', 'Wash human hair extensions every 2–3 months in five steps: detangle, rinse, cleanse, condition and dry.', stepsFrom('.care-steps li'), path), { '@id': `${LC.abs(path)}#howto-care` }),
      LC.itemListLd(extProducts, path, 'Le Chic Beauty Remy human hair extensions'),
      LC.faqLd(faqs, path)
    ]
  });
})();
